module.exports = __webpack_public_path__ + "img/icon13.18a12e5.png";